import { createSelector } from '@ngrx/store';
import { selectFeature } from 'src/app/clinical/store/selectors/clinical.selectors';

export const selectPerformanceEvalLoading = createSelector(
    selectFeature,
    (state) => state.performanceEval.viewMode === null
);

export const selectPerformanceEval = createSelector(selectFeature, (state) => state.performanceEval.performanceEval);

export const selectPerformanceEvalDialogViewMode = createSelector(
    selectFeature,
    (state) => state.performanceEval.viewMode
);
